import _ from 'lodash'

/**
 * Returns the field IDs that will be requested for the record list widget.
 * These are all the field IDs specifically mentioned by the columns and also
 * the field for the primary key.
 * @param {FormWidgetColumn[]} columns
 * @param {Dataset} dataset
 * @returns {Number[]} the relevant field IDs, sorted by ID
 */
function getRecordListFieldIds(columns, dataset) {
	let recordFieldIds = _.map(columns, 'fieldId')
	let pkId = dataset.get('primaryKeyFieldId')
	if (pkId && !_.includes(recordFieldIds, pkId)) {
		recordFieldIds.push(pkId)
	}
	recordFieldIds.sort()
	return recordFieldIds
}

export default getRecordListFieldIds

getRecordListFieldIds.__filename__ = 'forms/widgets/get-record-list-field-ids.js'
